const NAME = "TYPES_OF_SKILLS_TRANSVERSAL";

export default NAME;
